import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

function readPreference(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  return window.matchMedia?.(QUERY).matches === true;
}

/**
 * Tracks the OS "reduce motion" setting, and keeps tracking it: a visitor can
 * change the setting while the page is open.
 */
export function usePrefersReducedMotion(): boolean {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(readPreference);

  useEffect(() => {
    const query = window.matchMedia?.(QUERY);
    if (!query?.addEventListener) {
      return;
    }

    const handleChange = (event: MediaQueryListEvent): void => {
      setPrefersReducedMotion(event.matches);
    };

    query.addEventListener('change', handleChange);
    return () => query.removeEventListener('change', handleChange);
  }, []);

  return prefersReducedMotion;
}
